import axios from 'axios';

import { DefaultApiResponse } from '../_types';
import { parseSubjectsListForUI, parseSubjectForUI } from './subjects.parsers';
import { Subject, SubjectDetails, SubjectDetailsDto, SubjectDto } from './subjects.types';

const endpoints = {
  subjects: 'exercises/subjects/',
};

type GetSubjectsListQuery = () => Promise<Subject[]>;
type GetSubject = () => Promise<SubjectDetails>;

const subjectsApi = {
  getSubject:
    (subjectId: number | string): GetSubject =>
    async () => {
      const response = await axios.get<GetSubject, DefaultApiResponse<SubjectDetailsDto>>(`${endpoints.subjects}${subjectId}/`);
      return parseSubjectForUI(response.data);
    },
  getSubjectsList: (): GetSubjectsListQuery => async () => {
    const response = await axios.get<GetSubjectsListQuery, DefaultApiResponse<SubjectDto[]>>(endpoints.subjects);
    return parseSubjectsListForUI(response.data);
  },
};

export default subjectsApi;
